<template lang="pug">
  div
    el-row(
      type="flex",
      justify="space-between",
      align="bottom"
    )
      div.flex
        p.label {{label}}
          span(v-if="required").required &nbsp *
        slot(name="info")
      el-tooltip.item(
        effect='dark',
        :content='content',
        placement="left"
      )
        el-button.btn(
          v-if="hasButton &&  rotateButton",
          type="text",
          v-action-rotate="true",
          @click="$emit('click')",
          size="mini",
        )
          i(v-if="nome", class="material-icons" ) {{ nome }}
        el-button.btn(
          v-if="hasButton && !rotateButton",
          type="text",
          @click="$emit('click')",
          size="mini",
        )
          i(v-if="nome", class="material-icons" ) {{ nome }}
    el-row
      .divider(v-if="showBorder")
</template>

<script>

export default {
  props: {
    label: {
      type: String,
      required: true
    },
    hasButton: {
      type: Boolean,
      required: true
    },
    showBorder: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      required: true
    },
    nome: {
      type: String,
      default: 'autorenew'
    },
    rotateButton: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      current: 0
    }
  }

}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

  .label {
    font-weight: bold;
    color: #424242;

    .required {
      color: $error;
    }
  }

  .divider {
    border: 1px solid $border-color;
    margin-bottom: 10px;
  }

  .btn {
    padding: 5px;
    color: $color-primary;
  }

  .flex {
    display: flex;
    align-items: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/AppDividerRefreshButton.vue